import type { RouteLocationRaw } from 'vue-router'
import type { NavigateToOptions } from '#app/composables/router'

export const useLinks = () => {
  const {
    public: { appEnvironment, adminDevUrl, adminUrl, baseUrl },
  } = useRuntimeConfig()

  const isDevelopment = computed(
    () => (appEnvironment ? appEnvironment : '$NUXT_PUBLIC_APP_ENVIRONMENT') === 'development'
  )

  const BASE_URL = computed(() => (baseUrl ? baseUrl : '$NUXT_PUBLIC_BASE_URL'))

  const ADMIN_URL = computed(() =>
    isDevelopment.value
      ? adminDevUrl
        ? adminDevUrl
        : '$NUXT_PUBLIC_ADMIN_DEV_URL'
      : adminUrl
        ? adminUrl
        : '$NUXT_PUBLIC_ADMIN_URL'
  )

  return {
    BASE_URL,
    ADMIN_URL,
  }
}

export const getLinkType = (linkType: string) => {
  let serializedType = linkType
  switch (linkType) {
    case 'section':
    case 'product-list-color':
    case 'product-list-flower':
    case 'product-list-occasions':
      serializedType = 'tag'
      break
  }
  return serializedType
}

export const appNavigateTo = async (to?: RouteLocationRaw | null, options?: NavigateToOptions) => {
  const { locale, dataLang } = useLocale()
  const requstURL = useRequestURL()
  const parsedOptions = JSON.parse(JSON.stringify(options ?? {}))
  const { public: config } = useRuntimeConfig()
  const nuxtApp = useNuxtApp()

  if (typeof to === 'string') {
    const toWithLocale = getURLFromHref(to)
    try {
      if (toWithLocale.host === requstURL.host) {
        return navigateTo(
          `${toWithLocale.pathname}${toWithLocale.search}${toWithLocale.hash}`,
          parsedOptions
        )
      } else {
        return navigateTo(toWithLocale.href, parsedOptions)
      }
    } catch (e) {
      console.log(e)
    }
  } else {
    const toWithLocale = JSON.parse(JSON.stringify(to))
    if (!options?.external) {
      if (!toWithLocale.query) {
        toWithLocale.query = {}
      }
      if (
        config.localesInQuery ||
        (nuxtApp.$sharedComponentsOptions &&
          'options' in nuxtApp.$sharedComponentsOptions &&
          nuxtApp.$sharedComponentsOptions?.options &&
          'i18n' in nuxtApp.$sharedComponentsOptions?.options &&
          typeof nuxtApp.$sharedComponentsOptions?.options?.i18n === 'object' &&
          'localesInQuery' in nuxtApp.$sharedComponentsOptions?.options?.i18n &&
          nuxtApp.$sharedComponentsOptions?.options?.i18n?.localesInQuery)
      ) {
        toWithLocale.query.lang = locale.value
        toWithLocale.query.dataLang = dataLang.value
      }
    }
    try {
      return navigateTo(toWithLocale, options)
    } catch (e) {
      console.log(e)
    }
  }
}
export const getURLFromHref = (href: string | Ref<string>) => {
  const { locale, dataLang } = useLocale()
  const { public: config } = useRuntimeConfig()

  let hrefWithLang: URL
  const requstURL = useRequestURL()
  try {
    hrefWithLang = new URL(unref(href)) // zkusí absolutní
  } catch (err) {
    // když selže, je to relativní => přidej base
    hrefWithLang = new URL(unref(href), requstURL.origin)
  }
  if (requstURL.origin === hrefWithLang.origin && config.localesInQuery) {
    hrefWithLang.searchParams.set('lang', locale.value)
    hrefWithLang.searchParams.set('dataLang', dataLang.value)
  }
  return hrefWithLang
}
